<template>
  <v-app>
    <v-app-bar app color="#333" dark class="elevation-0 pt-1">
      <a href="/">
        <img
          src="https://images.theoutdoorwire.com/2020/01/22/5dcfb1a7-17d0-47f5-99df-ef1b1db45d4d_211x41.png"
        />
      </a>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    //
  }),
};
</script>
